// extracted by mini-css-extract-plugin
export default {"cls1":"ViewAllSuggestions-cls1__he","cls2":"ViewAllSuggestions-cls2_n4D ViewAllSuggestions-cls1__he"};